import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="bank"
export default class extends Controller {
  static targets = [
    "bankCode",
    "branchCodeBtn",
    "byBankNameInput",
    "byBranchNameInput",
    "setBankCode",
    "editBankCode",
    "branchBlock",
    "setBranchCode",
    "editBranchCode",
    "setBranchBtn",
  ];

  connect() {
    this.bankNameToggle(true);
  }

  searchBank(event) {
    const message = document.getElementById("bank-search-message");
    if (this.byBankNameInputTarget.value.trim() === "") {
      event.preventDefault();
      message.textContent = "銀行名を入力してください。";
    } else {
      message.textContent = "";
    }
  }

  searchBranch(event) {
    const message = document.getElementById("branch-search-message");
    if (this.byBranchNameInputTarget.value.trim() === "") {
      event.preventDefault();
      message.textContent = "支店名を入力してください。";
    } else {
      message.textContent = "";
    }
  }

  // drawer_controller.jsのopenを呼び出す
  openDrawer(event) {
    event.preventDefault();
    const targetId = event.currentTarget.dataset.targetId;
    const drawerController = this.application.getControllerForElementAndIdentifier(
      document.getElementById(targetId),
      "drawer",
    );
    drawerController.open(targetId);
  }

  // drawer_controller.jsのcloseを呼び出す
  async closeDrawer() {
    const drawerController = this.application.getControllerForElementAndIdentifier(
      document.querySelector("[data-controller='drawer']"),
      "drawer",
    );
    drawerController.close();
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 300);
    });
  }

  // 銀行選択時の処理
  async selectBank(event) {
    const bankCode = event.currentTarget.dataset.bankCode;
    const bankName = event.currentTarget.dataset.bankName;
    const branchPath = event.currentTarget.dataset.branchPath;
    document.getElementById("promoter_bank_account_bank_name").textContent = bankName;
    document.getElementById("promoter_bank_account_bank_code").value = bankCode;
    document.getElementById("promoter_bank_account_bank_code").dataset.branchPath = branchPath;
    this.clearBranch();
    this.branchList(branchPath);
    this.bankNameToggle(false);
    await this.closeDrawer();
    this.setBranchBtnTarget.click();
  }

  // 支店一覧を更新する
  branchList(branchPath) {
    Turbo.visit(branchPath, { frame: "branch_list" });
  }

  // 選択済みの支店情報をクリアする
  clearBranch() {
    document.getElementById("promoter_bank_account_branch_name").textContent = "";
    document.getElementById("promoter_bank_account_branch_code").value = "";
  }

  // 支店選択時の処理
  selectBranch(event) {
    const branchCode = event.currentTarget.dataset.branchCode;
    const branchName = event.currentTarget.dataset.branchName;
    document.getElementById("promoter_bank_account_branch_name").textContent = branchName;
    document.getElementById("promoter_bank_account_branch_code").value = branchCode;
    this.closeDrawer();
    this.branchNameToggle();
  }

  // 金融機関名の表示切り替え処理
  bankNameToggle(connect_flag) {
    if (this.hasSetBankCodeTarget && this.hasEditBankCodeTarget) {
      const setBankCode = this.setBankCodeTarget;
      const editBankCode = this.editBankCodeTarget;
      if (document.getElementById("promoter_bank_account_bank_name").textContent.length > 0) {
        setBankCode.style.display = "none";
        editBankCode.style.display = "block";
      } else {
        setBankCode.style.display = "block";
        editBankCode.style.display = "none";
      }
      this.branchNameToggle(connect_flag);
    }
  }

  // 支店名の表示切り替え処理
  branchNameToggle(connect_flag) {
    if (this.hasBranchBlockTarget && this.hasSetBranchCodeTarget && this.hasEditBranchCodeTarget) {
      const branchBlock = this.branchBlockTarget;
      const setBranchCode = this.setBranchCodeTarget;
      const editBranchCode = this.editBranchCodeTarget;
      if (document.getElementById("promoter_bank_account_bank_name").textContent.length > 0) {
        branchBlock.style.display = "block";
        if (connect_flag) {
          this.branchList(this.bankCodeTarget.dataset.branchPath);
        }
        if (document.getElementById("promoter_bank_account_branch_name").textContent.length > 0) {
          setBranchCode.style.display = "none";
          editBranchCode.style.display = "block";
        } else {
          setBranchCode.style.display = "block";
          editBranchCode.style.display = "none";
        }
      } else {
        branchBlock.style.display = "none";
        setBranchCode.style.display = "none";
        editBranchCode.style.display = "none";
      }
    }
  }
}
